import { render, staticRenderFns } from "./AddWebhook.vue?vue&type=template&id=3f976ba4&"
import script from "./AddWebhook.vue?vue&type=script&lang=js&"
export * from "./AddWebhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports